import { render } from "./EventCapacity.vue?vue&type=template&id=63e68884"
import script from "./EventCapacity.vue?vue&type=script&lang=js"
export * from "./EventCapacity.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__